module.exports = __webpack_public_path__ + "img/11.31cc569b.png";